import { useEffect, useState } from "react";
import { PartnerApi } from "../api/partner.api";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useAuthStore } from "../store/auth.store";
import RenewalsByQuarter from "./Renewals/RenewalsByQuarter";
import RenewalsByCustomer from "./Renewals/RenewalsByCustomer";
import { useTranslation } from "../hooks/useTranslation";

function Renewals() {
  const { t } = useTranslation();
  const kotva = window.location.hash
    ? JSON.parse(decodeURIComponent(window.location.hash.replace("#", "")))
    : null;
  console.log("kotva", kotva);
  const token = useAuthStore((state) => state.token);
  const [page, setPage] = useState("quarter");

  const [pageWaiting, setPageWaiting] = useState(kotva?.pageWaiting);
  const [pageInProgress, setPageInProgress] = useState(kotva?.pageInProgress);
  const [pageRenewal, setPageRenewal] = useState(kotva?.pageRenewal);
  const [pageDone, setPageDone] = useState(kotva?.pageDone);
  const [pageLost, setPageLost] = useState(kotva?.pageLost);

  const [filter, setFilter] = useState([]);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("renewals.title"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    let states = [];
    pageWaiting && states.push("pageWaiting");
    pageInProgress && states.push("pageInProgress");
    pageRenewal && states.push("pageRenewal");
    pageDone && states.push("pageDone");
    pageLost && states.push("pageLost");
    setFilter(states);
  }, [pageWaiting, pageInProgress, pageRenewal, pageDone, pageLost]);

  return (
    <>
      <div className="card mt-6">
        <div className="card-body">
          <div className="float-end d-none d-md-block">
            <button
              type="button"
              className={
                "btn me-3 mb-2 " +
                (pageWaiting ? "btn-warning" : "btn-secondary")
              }
              onClick={() => setPageWaiting(!pageWaiting)}
            >
              {t("renewals.pending")}
            </button>
            <button
              type="button"
              className={
                "btn me-3 mb-2 " +
                (pageInProgress ? "btn-warning" : "btn-secondary")
              }
              onClick={() => setPageInProgress(!pageInProgress)}
            >
              {t("renewals.inProgress")}
            </button>
            <button
              type="button"
              className={
                "btn me-3 mb-2 " +
                (pageRenewal ? "btn-warning" : "btn-secondary")
              }
              onClick={() => setPageRenewal(!pageRenewal)}
            >
              {t("renewals.renewing")}
            </button>
            <button
              type="button"
              className={
                "btn me-3 mb-2 " + (pageDone ? "btn-success" : "btn-secondary")
              }
              onClick={() => setPageDone(!pageDone)}
            >
              {t("renewals.renewed")}
            </button>
            <button
              type="button"
              className={
                "btn me-3 mb-2 " + (pageLost ? "btn-danger" : "btn-secondary")
              }
              onClick={() => setPageLost(!pageLost)}
            >
              {t("renewals.lost")}
            </button>
            <button
              className="btn btn-success mb-2"
              onClick={() => PartnerApi.renewalsExport({ token })}
            >
              {t("common.exportXlsx")}
            </button>
          </div>
          <button
            className="btn btn-success d-md-none w-100 mb-4"
            onClick={() => PartnerApi.renewalsExport({ token })}
          >
            {t("common.exportXlsx")}
          </button>

          <ul className="mb-5 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
            <li className="nav-item">
              <span
                onClick={() => setPage("quarter")}
                className={
                  "cursor-pointer nav-link" +
                  (page == "quarter" ? " active" : "")
                }
                aria-current="page"
              >
                {t("renewals.byPeriod")}
              </span>
            </li>
            <li className="nav-item">
              <span
                onClick={() => setPage("customer")}
                className={
                  "cursor-pointer nav-link" +
                  (page == "customer" ? " active" : "")
                }
                aria-current="page"
              >
                {t("renewals.byCustomer")}
              </span>
            </li>
          </ul>

          {page == "quarter" && <RenewalsByQuarter filter={filter} />}

          {page == "customer" && <RenewalsByCustomer filter={filter} />}
        </div>
      </div>
    </>
  );
}

export default Renewals;
